<template>
  <div class="reply-container">
        <pre>{{text}}<br></pre>
        <textarea ref="rep" v-on:keypress="keyEvent($event)" v-model="text"></textarea>
        <div class="reply-buttons">
            <div class="reply-button reply-button-file">
                <file-upload
                    ref="upload"
                    name="download"
                    v-model="files"
                    :post-action="uri + '/file/upload'"
                    @input-file="inputFile"
                    @input-filter="inputFilter"
                ></file-upload>
            <div v-for="(file, index) in files" :key="index">{{file.progress}}</div>
            </div>
            <div @click="send()" class="reply-button reply-button-send"></div>
        </div>
    </div>
</template>

<script>
import FileUpload from 'vue-upload-component'
import { mapState, mapMutations } from 'vuex'
import api from '../api'

export default {
    components: {
        FileUpload
    },
    data() {
        return {
            text: '',
            type: 'text',
            uri: '//api.pcbcart.com/',
            files: []
        }
    },
    computed: {
        ...mapState(['user', 'show_tip']),
        ...mapState('messageList', ['admin', 'reply']),
    },
    mounted() {
        this.$refs.rep.focus()
    },
    methods: {
        ...mapMutations(['closeTip']),
        ...mapMutations('messageList', ['updateReply']),
        send() {
            if (!this.text.trim().length) return
            this.text = this.text.replace(/\n/g, '<br>' )
            this.updateReply({ text: this.text, status: 'sending'})
            this.$remote.$emit('message', {
                data: this.reply.text,
                from_user_uuid: this.user.uuid,
                to_user_uuid: this.admin ? this.admin.admin_uuid : null,
                conversation_id: this.admin ? this.admin.conversation_id : 0,
                type: this.type
            })

            this.type = 'text'
            this.text = ''
            this.updateReply({text: this.text, status: 'sending'})
            this.$refs.rep.focus()

            if (this.show_tip) {
                this.closeTip()
            }
        },
        keyEvent(e) {
            if (e.keyCode == 10) {
                this.text += '\n'
            }
            if (e.keyCode == 13) {
                e.preventDefault()
                this.send()
                return
            }
        },
        inputFile: function (newFile, oldFile) {
            if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
                if (!this.$refs.upload.active) {
                    this.$refs.upload.active = true
                }
            }
            // if (newFile.progress !== oldFile.progress) {
            //     console.log('progress', newFile.progress, newFile)
            // }
            
            if (newFile && oldFile && !newFile.active && oldFile.active) {
                // 获得相应数据
                this.type = 'file'
                this.text = newFile.response.data
                this.send()
                console.log('response', newFile.response)
                if (newFile.xhr) {
                //  获得响应状态码
                    console.log('status', newFile.xhr.status)
                }
            }
        },
        /**
         * Pretreatment
         * @param  Object|undefined   newFile   读写
         * @param  Object|undefined   oldFile   只读
         * @param  Function           prevent   阻止回调
         * @return undefined
         */
        inputFilter: function (newFile, oldFile, prevent) {
            // 过滤不是支持后缀的文件
            // zip,rar,docx,doc,xlsx,xls,txt,csv,pdf
            if (!/\.(zip|rar|docx|doc|xlsx|xls|txt|csv|pdf|)$/i.test(newFile.name)) {
            //   this.$message.error('文件格式错误, 目前支持文件格式为: zip,rar,docx,doc,xlsx,xls,txt,csv,pdf')
                window.alert('only zip,rar,docx,doc,xlsx,xls,txt,csv,pdf can be accepted')
                return prevent()
            }

            // 创建 blob 字段 用于图片预览
            newFile.blob = ''
            let URL = window.URL || window.webkitURL
            if (URL && URL.createObjectURL) {
                newFile.blob = URL.createObjectURL(newFile.file)
            }
        }
    }
}
</script>



<style lang="scss" scoped>
.reply-container { position: relative; min-height: 55px; max-height: 200px;
    pre {visibility: hidden; padding: 18px; padding-right: 100px; padding-left: 30px; width: 100%; margin: 0; display: block; text-align: left;
        height: 100%; font-size: 15px; font-weight: 400; line-height: 1.33; white-space: pre-wrap; word-wrap: break-word;
    }
    textarea {position: absolute; bottom: 0; left: 0; color: #565867; background-color: #f4f7f9; outline: none;
        font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
        resize: none; border: none; transition: all .2s ease;padding: 18px; padding-right: 100px; padding-left: 30px;
        width: 100%;height: 100%;font-size: 15px; font-weight: 400; line-height: 1.33; white-space: pre-wrap; word-wrap: break-word;
        overflow-y: auto;
        &:focus { background-color: #fff; box-shadow: 0 0 100px 0 rgba(150,165,190,.24);}
    }
    .reply-buttons {position: absolute; top: 0; right: 15px;
        .reply-button { position: relative; float: left; display: block; cursor: pointer; width: 30px;
            opacity: .8; transition: opacity .2s ease; height: 55px;
            &::before { position: absolute; top: 20px; background-position: 50%; background-size: 18px 18px;
                background-repeat: no-repeat; content: " "; width: 18px; height: 18px; left: 5px;
            }
            .file-uploads{width: 100%;height: 100%;}
        }
        .reply-button-file {
            &::before {background-image: url('../assets/file.png');}
            label {width: 100%; height: 100%; cursor: pointer;}
        }
        .reply-button-send {
            &::before {background-image: url('../assets/send.png');}
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Reply.vue